import '../../styles/PrivateLayout/Sider.css';

import { HomeOutlined }          from '@ant-design/icons';
import { ShopOutlined }          from '@ant-design/icons';
import { UnorderedListOutlined } from '@ant-design/icons';
import { useState }              from 'react';
import { Link }                  from 'react-router-dom';
import { observer }              from 'mobx-react';
import { Layout }                from 'antd';
import { Menu }                  from 'antd';
import type { MenuProps }        from 'antd';
import { FileOutlined }          from '@ant-design/icons';
import AdvertiserShowModel       from 'models/AdvertiserShowModel';
import DemandConfigModel         from 'models/DemandConfigModel';
import { privateLayoutStore }    from 'stores/index';
import { navigationStore }       from 'stores/NavigationStore';
import SiderAdvertiser           from './components/SiderAdvertiser';
import ProvidersShowModalAction  from '../Stand/Dashboard/ProvidersShowModalAction';
import FormattedMessageWrapper   from 'components/App/FormattedMessageWrapper';
import rights                    from 'utils/rights';

export const KEY_SHOWS = 'shows';
export const KEY_STANDS = 'stands';
export const KEY_DEMANDS = 'demands';
export const KEY_DOCUMENTS = 'documents';
export const KEY_PROVIDERS_SHOW_MODAL = 'providers_show_modal';

const Sider = observer(({
  collapsed,
  setCollapsed,
}: {
  collapsed: boolean,
  setCollapsed: (collapsed: boolean) => void,
}) => {
  const {
    advertiserCollection,
    advertiserShowCollection,
    showId: currentShowId,
    demandConfigCollection,
    providerCollection,
    providerShowCategoryCollection,
    providerShowCollection,
    show,
  } = privateLayoutStore;

  const currentShowDemandConfigs = demandConfigCollection.filter(
    (dc: DemandConfigModel) => dc.showId?.toString() === currentShowId?.toString(),
  );

  const { standDocumentsOption } = show;

  const selectedKeys = [ navigationStore.activeMenuKey ];

  const menuItems: MenuProps['items'] = [
    rights.for.show.view && {
      key: KEY_SHOWS,
      label: (
        <Link className="sider-item" to={`/salons/${currentShowId}`}>
          <HomeOutlined />
          <span>
            <FormattedMessageWrapper id="Salon" />
          </span>
        </Link>
      ),
    },
    !!show.isLoaded && {
      key: KEY_STANDS,
      label: (
        <Link className="sider-item" to={`/salons/${currentShowId}/stands`}>
          <ShopOutlined />
          <span>
            <FormattedMessageWrapper id="Stands" />
          </span>
        </Link>
      ),
    },
    !!currentShowDemandConfigs.length && {
      key: KEY_DEMANDS,
      label: (
        <Link className="sider-item" to={`/salons/${currentShowId}/demandes`}>
          <UnorderedListOutlined />
          <span>
            <FormattedMessageWrapper id="Demandes" />
          </span>
        </Link>
      ),
    },
    !!standDocumentsOption && {
      key: KEY_DOCUMENTS,
      label: (
        <Link className="sider-item" to={`/salons/${currentShowId}/documents`}>
          <FileOutlined />
          <span>
            <FormattedMessageWrapper id="Documents" />
          </span>
        </Link>
      ),
    },
    {
      className: 'AppSider__MenuProviders',
      key: KEY_PROVIDERS_SHOW_MODAL,
      label: (
        <ProvidersShowModalAction
          providerCollection={providerCollection}
          providerShowCategoryCollection={providerShowCategoryCollection}
          providerShowCollection={providerShowCollection}
        />
      ),
    },
  ].filter(Boolean) as MenuProps['items'];

  return (
    <Layout.Sider
      className="AppSider__container"
      collapsed={collapsed}
      collapsible
      id="astech-private-layout-sider"
      onCollapse={setCollapsed}
    >
      <Link to="/">
        <div className="astechlogo" />
      </Link>

      {!!currentShowId && (
        <Menu
          className="AppSider__MenuTop"
          defaultSelectedKeys={selectedKeys}
          items={menuItems}
          mode="inline"
          selectedKeys={selectedKeys}
          theme="dark"
        />
      )}

      <div
        className={`AppSider__MenuBottom ${collapsed ? 'collapsed' : ''}`}
        style={{
          width: collapsed ? '80px' : '200px',
        }}
      >
        <div className="AppSider__advertiserShowsContainer">
          {advertiserShowCollection.map((advertiserShow: AdvertiserShowModel) => (
            <SiderAdvertiser
              advertiserCollection={advertiserCollection}
              advertiserShow={advertiserShow}
              key={advertiserShow.iri}
            />
          ))}
        </div>
      </div>
    </Layout.Sider>
  );
});

const SiderWrapper = () => {
  const [collapsed, setCollapsed] = useState(false);

  return <Sider
    collapsed={collapsed}
    setCollapsed={setCollapsed}
  />;
}

export default SiderWrapper;